import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import './styles/notifications.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ErrorBoundary from './components/ErrorBoundary';
// Importar e executar supressor de erros de extensões
import './utils/suppressExtensionErrors';

// Verificar se o elemento root existe antes de renderizar
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Elemento root não encontrado! Verifique se existe um elemento com id="root" no HTML.');
}

const root = ReactDOM.createRoot(rootElement);

// Tratamento global de erros não capturados
window.addEventListener('error', (event) => {
  console.error('🚨 Erro global capturado:', event.error);
  // Não prevenir o comportamento padrão para permitir que ErrorBoundary capture
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('🚨 Promise rejeitada não tratada:', event.reason);
  // Não prevenir o comportamento padrão
});

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
